import styled, { css } from 'styled-components'

import { ButtonAsync, muiRipple } from '@subaio/components'

import { helpers } from 'styles'

export const solidStyle = css`
	color: ${helpers.color.actionLabel};
	background-color: ${helpers.color.action};
	-webkit-font-smoothing: antialiased;
	font: ${helpers.fonts.button};
	border-radius: 4px;
	height: 36px;
	padding: ${helpers.spacing.small} ${helpers.spacing.large};
	transition: color 0.2s, background-color 0.2s;
	isolation: isolate;

	&:is(:focus-visible, :hover) {
		background-color: ${helpers.color.actionHover};
	}

	&:focus-visible {
		outline: 2px solid ${helpers.color.link};
		outline-offset: -2px;
	}

	&:disabled {
		background-color: ${helpers.color.actionDisabled};
		color: ${helpers.color.actionDisabledLabel};
	}

	${muiRipple()}
`

export const ButtonSolid = styled(ButtonAsync)`
	${solidStyle}
`
